import React from "react";

import { StyledSVG } from "../StyledIcon";

export const EmpathyIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.9939 12.7143C24.864 9.92559 23.7233 7.27822 21.7837 5.29505C19.7201 3.18526 16.9214 2 14.0032 2C11.085 2 8.28627 3.18526 6.22276 5.29505C4.28309 7.27823 3.14239 9.92559 3.01247 12.7143L2 22.3572H4.89268C4.93552 23.5485 5.19236 24.7237 5.65204 25.8268C6.15761 27.0401 6.89863 28.1425 7.83279 29.0711C8.76696 29.9997 9.87598 30.7362 11.0965 31.2388C12.3171 31.7413 13.6252 32 14.9463 32C16.2674 32 17.5756 31.7413 18.7962 31.2388C20.0167 30.7362 21.1257 29.9997 22.0599 29.0711C22.9941 28.1425 23.7351 27.0401 24.2406 25.8268C24.7003 24.7237 24.9572 23.5485 25 22.3572L24.9939 12.7143Z"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.0061 18.7143C15.136 15.9256 16.2767 13.2782 18.2163 11.295C20.2799 9.18526 23.0786 8 25.9968 8C28.915 8 31.7137 9.18526 33.7772 11.295C35.7169 13.2782 36.8576 15.9256 36.9875 18.7143L38 28.3572H35.1073C35.0645 29.5485 34.8076 30.7237 34.348 31.8268C33.8424 33.0401 33.1014 34.1425 32.1672 35.0711C31.233 35.9997 30.124 36.7362 28.9035 37.2388C27.6829 37.7413 26.3748 38 25.0537 38C23.7326 38 22.4244 37.7413 21.2038 37.2388C19.9833 36.7362 18.8743 35.9997 17.9401 35.0711C17.0059 34.1425 16.2649 33.0401 15.7594 31.8268C15.2997 30.7237 15.0428 29.5485 15 28.3572L15.0061 18.7143Z"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
      />
      <circle cx="10" cy="13" r="1" fill={iconColor} vectorEffect="non-scaling-stroke" />
      <circle cx="31" cy="20" r="1" fill={iconColor} vectorEffect="non-scaling-stroke" />
    </StyledSVG>
  );
};
